export const preloadVehicleMakeList = [
  {
    'id': 1,
    'name': 'ARO'
  },
  {
    'id': 2,
    'name': 'Abarth'
  },
  {
    'id': 3,
    'name': 'Acura'
  },
  {
    'id': 4,
    'name': 'Alfa Romeo'
  },
  {
    'id': 5,
    'name': 'Aprilia'
  },
  {
    'id': 6,
    'name': 'Asia'
  },
  {
    'id': 7,
    'name': 'Aston Martin'
  },
  {
    'id': 8,
    'name': 'Audi'
  },
  {
    'id': 9,
    'name': 'Austin'
  },
  {
    'id': 10,
    'name': 'Autosan'
  },
  {
    'id': 11,
    'name': 'BARKAS'
  },
  {
    'id': 12,
    'name': 'BAW'
  },
  {
    'id': 13,
    'name': 'BMW'
  },
  {
    'id': 14,
    'name': 'BYD'
  },
  {
    'id': 15,
    'name': 'Bajaj'
  },
  {
    'id': 16,
    'name': 'Benelli'
  },
  {
    'id': 17,
    'name': 'Bentley'
  },
  {
    'id': 18,
    'name': 'Brilliance'
  },
  {
    'id': 19,
    'name': 'Buell'
  },
  {
    'id': 20,
    'name': 'Buick'
  },
  {
    'id': 21,
    'name': 'CF Moto'
  },
  {
    'id': 22,
    'name': 'CPI'
  },
  {
    'id': 23,
    'name': 'Cadillac'
  },
  {
    'id': 24,
    'name': 'Case'
  },
  {
    'id': 25,
    'name': 'Caterpillar'
  },
  {
    'id': 26,
    'name': 'Changhe'
  },
  {
    'id': 27,
    'name': 'Chery'
  },
  {
    'id': 28,
    'name': 'Chevrolet'
  },
  {
    'id': 29,
    'name': 'Chrysler'
  },
  {
    'id': 30,
    'name': 'Citroen'
  },
  {
    'id': 31,
    'name': 'Cizeta'
  },
  {
    'id': 32,
    'name': 'Corrado'
  },
  {
    'id': 33,
    'name': 'Corvet'
  },
  {
    'id': 34,
    'name': 'DAF'
  },
  {
    'id': 35,
    'name': 'Dacia'
  },
  {
    'id': 36,
    'name': 'Dadi'
  },
  {
    'id': 37,
    'name': 'Daewoo'
  },
  {
    'id': 38,
    'name': 'Daihatsu'
  },
  {
    'id': 39,
    'name': 'Defiant'
  },
  {
    'id': 40,
    'name': 'Delta'
  },
  {
    'id': 41,
    'name': 'Den Oudsten'
  },
  {
    'id': 42,
    'name': 'Derways'
  },
  {
    'id': 43,
    'name': 'Dodge'
  },
  {
    'id': 44,
    'name': 'Dong Feng'
  },
  {
    'id': 45,
    'name': 'Doninvest'
  },
  {
    'id': 46,
    'name': 'Ducati'
  },
  {
    'id': 47,
    'name': 'EOS'
  },
  {
    'id': 48,
    'name': 'ERF'
  },
  {
    'id': 49,
    'name': 'Eagle'
  },
  {
    'id': 50,
    'name': 'Eriskay'
  },
  {
    'id': 51,
    'name': 'FAW'
  },
  {
    'id': 52,
    'name': 'FSO'
  },
  {
    'id': 53,
    'name': 'Fada'
  },
  {
    'id': 54,
    'name': 'Farmer'
  },
  {
    'id': 55,
    'name': 'Ferrari'
  },
  {
    'id': 56,
    'name': 'Fiat'
  },
  {
    'id': 57,
    'name': 'Ford'
  },
  {
    'id': 58,
    'name': 'Forward'
  },
  {
    'id': 59,
    'name': 'Fosti'
  },
  {
    'id': 60,
    'name': 'Foton'
  },
  {
    'id': 61,
    'name': 'Freightliner'
  },
  {
    'id': 62,
    'name': 'GMC'
  },
  {
    'id': 63,
    'name': 'GWM'
  },
  {
    'id': 64,
    'name': 'Geely'
  },
  {
    'id': 65,
    'name': 'Geo'
  },
  {
    'id': 66,
    'name': 'Geon'
  },
  {
    'id': 67,
    'name': 'Gilera'
  },
  {
    'id': 68,
    'name': 'Gonow'
  },
  {
    'id': 69,
    'name': 'Great Wall'
  },
  {
    'id': 70,
    'name': 'Groz'
  },
  {
    'id': 71,
    'name': 'Hafei'
  },
  {
    'id': 72,
    'name': 'Hagie'
  },
  {
    'id': 73,
    'name': 'Hamm'
  },
  {
    'id': 74,
    'name': 'Harley-Davidson'
  },
  {
    'id': 75,
    'name': 'Honda'
  },
  {
    'id': 76,
    'name': 'Huabei'
  },
  {
    'id': 77,
    'name': 'Hummer'
  },
  {
    'id': 78,
    'name': 'Hyosung'
  },
  {
    'id': 79,
    'name': 'Hyundai'
  },
  {
    'id': 80,
    'name': 'I-VAN'
  },
  {
    'id': 81,
    'name': 'IFA'
  },
  {
    'id': 82,
    'name': 'IKCO'
  },
  {
    'id': 83,
    'name': 'Ideal'
  },
  {
    'id': 84,
    'name': 'Ikarus'
  },
  {
    'id': 85,
    'name': 'Infiniti'
  },
  {
    'id': 86,
    'name': 'Iran'
  },
  {
    'id': 87,
    'name': 'Isuzu'
  },
  {
    'id': 88,
    'name': 'Iveco'
  },
  {
    'id': 89,
    'name': 'JAC'
  },
  {
    'id': 90,
    'name': 'JCB'
  },
  {
    'id': 91,
    'name': 'Jaguar'
  },
  {
    'id': 92,
    'name': 'Jawa'
  },
  {
    'id': 93,
    'name': 'Jeep'
  },
  {
    'id': 94,
    'name': 'Jialing'
  },
  {
    'id': 95,
    'name': 'Jiangnan'
  },
  {
    'id': 96,
    'name': 'Jianshe'
  },
  {
    'id': 97,
    'name': 'Jinbei'
  },
  {
    'id': 98,
    'name': 'John Deere'
  },
  {
    'id': 99,
    'name': 'Jonway Ufo'
  },
  {
    'id': 100,
    'name': 'KRONE'
  },
  {
    'id': 101,
    'name': 'Kanuni'
  },
  {
    'id': 102,
    'name': 'Karosa'
  },
  {
    'id': 103,
    'name': 'Kawasaki'
  },
  {
    'id': 104,
    'name': 'Keeway'
  },
  {
    'id': 105,
    'name': 'Kenworth'
  },
  {
    'id': 106,
    'name': 'Kia'
  },
  {
    'id': 107,
    'name': 'King Long'
  },
  {
    'id': 108,
    'name': 'Kinroad'
  },
  {
    'id': 109,
    'name': 'Kymco'
  },
  {
    'id': 110,
    'name': 'LAG'
  },
  {
    'id': 111,
    'name': 'LDV'
  },
  {
    'id': 112,
    'name': 'Lada'
  },
  {
    'id': 113,
    'name': 'Lamborghini'
  },
  {
    'id': 114,
    'name': 'Lancia'
  },
  {
    'id': 115,
    'name': 'Land Rover'
  },
  {
    'id': 116,
    'name': 'Landwind'
  },
  {
    'id': 117,
    'name': 'Lexus'
  },
  {
    'id': 118,
    'name': 'Liaz'
  },
  {
    'id': 119,
    'name': 'Lifan'
  },
  {
    'id': 120,
    'name': 'Lincoln'
  },
  {
    'id': 121,
    'name': 'Lublin'
  },
  {
    'id': 122,
    'name': 'MAN'
  },
  {
    'id': 123,
    'name': 'MG'
  },
  {
    'id': 124,
    'name': 'Maserati'
  },
  {
    'id': 125,
    'name': 'Massey'
  },
  {
    'id': 126,
    'name': 'Maybach'
  },
  {
    'id': 127,
    'name': 'Mazda'
  },
  {
    'id': 128,
    'name': 'Mercedes-Benz'
  },
  {
    'id': 129,
    'name': 'Mercury'
  },
  {
    'id': 130,
    'name': 'Mini'
  },
  {
    'id': 131,
    'name': 'Mitsubishi'
  },
  {
    'id': 132,
    'name': 'Mudan'
  },
  {
    'id': 133,
    'name': 'Musstang'
  },
  {
    'id': 134,
    'name': 'Neoplan'
  },
  {
    'id': 135,
    'name': 'New Holland'
  },
  {
    'id': 136,
    'name': 'Nissan'
  },
  {
    'id': 137,
    'name': 'Oltcit'
  },
  {
    'id': 138,
    'name': 'Opel'
  },
  {
    'id': 139,
    'name': 'Pannonia'
  },
  {
    'id': 140,
    'name': 'Peugeot'
  },
  {
    'id': 141,
    'name': 'Piaggio'
  },
  {
    'id': 142,
    'name': 'Pierce'
  },
  {
    'id': 143,
    'name': 'Plymouth'
  },
  {
    'id': 144,
    'name': 'Pontiac'
  },
  {
    'id': 145,
    'name': 'Porsche'
  },
  {
    'id': 146,
    'name': 'Proton'
  },
  {
    'id': 147,
    'name': 'Qianjiang'
  },
  {
    'id': 148,
    'name': 'Qingqi'
  },
  {
    'id': 149,
    'name': 'Raketa-Futong'
  },
  {
    'id': 150,
    'name': 'Ravon'
  },
  {
    'id': 151,
    'name': 'Ravonе'
  },
  {
    'id': 152,
    'name': 'Renault'
  },
  {
    'id': 153,
    'name': 'Rexon'
  },
  {
    'id': 154,
    'name': 'Robur'
  },
  {
    'id': 155,
    'name': 'Rocket'
  },
  {
    'id': 156,
    'name': 'Rolls Royce'
  },
  {
    'id': 157,
    'name': 'Rover'
  },
  {
    'id': 158,
    'name': 'SAAB'
  },
  {
    'id': 159,
    'name': 'SMA'
  },
  {
    'id': 160,
    'name': 'Saipa'
  },
  {
    'id': 161,
    'name': 'Samand'
  },
  {
    'id': 162,
    'name': 'Saturn'
  },
  {
    'id': 163,
    'name': 'Scania'
  },
  {
    'id': 164,
    'name': 'Seat'
  },
  {
    'id': 165,
    'name': 'Sensor'
  },
  {
    'id': 166,
    'name': 'Setra'
  },
  {
    'id': 167,
    'name': 'Shaanxi'
  },
  {
    'id': 168,
    'name': 'Shacman'
  },
  {
    'id': 169,
    'name': 'Shaolin'
  },
  {
    'id': 170,
    'name': 'Shawoom'
  },
  {
    'id': 171,
    'name': 'Shineray'
  },
  {
    'id': 172,
    'name': 'Simple'
  },
  {
    'id': 173,
    'name': 'Simson'
  },
  {
    'id': 174,
    'name': 'Skoda'
  },
  {
    'id': 175,
    'name': 'Skymoto'
  },
  {
    'id': 176,
    'name': 'Smart'
  },
  {
    'id': 177,
    'name': 'Soueast'
  },
  {
    'id': 178,
    'name': 'Spark'
  },
  {
    'id': 179,
    'name': 'Speed Gear'
  },
  {
    'id': 180,
    'name': 'SsangYong'
  },
  {
    'id': 181,
    'name': 'Stinger'
  },
  {
    'id': 182,
    'name': 'Subaru'
  },
  {
    'id': 183,
    'name': 'Suzuki'
  },
  {
    'id': 184,
    'name': 'Sym'
  },
  {
    'id': 185,
    'name': 'TATA'
  },
  {
    'id': 186,
    'name': 'TK-U'
  },
  {
    'id': 187,
    'name': 'TXM'
  },
  {
    'id': 188,
    'name': 'Talbot'
  },
  {
    'id': 189,
    'name': 'Tatra'
  },
  {
    'id': 190,
    'name': 'Temsa'
  },
  {
    'id': 191,
    'name': 'Tesla'
  },
  {
    'id': 192,
    'name': 'Tianma'
  },
  {
    'id': 193,
    'name': 'Tiger'
  },
  {
    'id': 194,
    'name': 'Toyota'
  },
  {
    'id': 195,
    'name': 'Trabant'
  },
  {
    'id': 196,
    'name': 'Triumph'
  },
  {
    'id': 197,
    'name': 'Truva'
  },
  {
    'id': 198,
    'name': 'Van'
  },
  {
    'id': 199,
    'name': 'Van Hool'
  },
  {
    'id': 200,
    'name': 'Vauxhall'
  },
  {
    'id': 201,
    'name': 'Ventus'
  },
  {
    'id': 202,
    'name': 'Viking'
  },
  {
    'id': 203,
    'name': 'Viper'
  },
  {
    'id': 204,
    'name': 'Volkswagen'
  },
  {
    'id': 205,
    'name': 'Volvo'
  },
  {
    'id': 206,
    'name': 'Vortex'
  },
  {
    'id': 207,
    'name': 'Wartburg'
  },
  {
    'id': 208,
    'name': 'Willis'
  },
  {
    'id': 209,
    'name': 'YIben'
  },
  {
    'id': 210,
    'name': 'Yamaha'
  },
  {
    'id': 211,
    'name': 'Yamasaki'
  },
  {
    'id': 212,
    'name': 'Youyi'
  },
  {
    'id': 213,
    'name': 'Yuejin'
  },
  {
    'id': 214,
    'name': 'Yutong'
  },
  {
    'id': 215,
    'name': 'ZN'
  },
  {
    'id': 216,
    'name': 'ZUK'
  },
  {
    'id': 217,
    'name': 'ZX AUTO'
  },
  {
    'id': 218,
    'name': 'Zastava'
  },
  {
    'id': 219,
    'name': 'Zhejiang'
  },
  {
    'id': 220,
    'name': 'Zhongxing'
  },
  {
    'id': 221,
    'name': 'Zonder'
  },
  {
    'id': 222,
    'name': 'Zongshen'
  },
  {
    'id': 223,
    'name': 'name_auto_maker'
  },
  {
    'id': 224,
    'name': 'name_auto_maker_1'
  },
  {
    'id': 225,
    'name': 'АЗЛК'
  },
  {
    'id': 226,
    'name': 'АС'
  },
  {
    'id': 227,
    'name': 'БАЗ'
  },
  {
    'id': 228,
    'name': 'БелАЗ'
  },
  {
    'id': 229,
    'name': 'Беларус'
  },
  {
    'id': 230,
    'name': 'Богдан'
  },
  {
    'id': 231,
    'name': 'Борекс'
  },
  {
    'id': 232,
    'name': 'ВАЗ'
  },
  {
    'id': 233,
    'name': 'ВИС'
  },
  {
    'id': 234,
    'name': 'Восход'
  },
  {
    'id': 235,
    'name': 'Вятка'
  },
  {
    'id': 236,
    'name': 'ГАЗ'
  },
  {
    'id': 237,
    'name': 'ГАЗ-ЧАЗ'
  },
  {
    'id': 238,
    'name': 'ГАЛАЗ'
  },
  {
    'id': 239,
    'name': 'ГЗСА'
  },
  {
    'id': 240,
    'name': 'ДЗ'
  },
  {
    'id': 241,
    'name': 'ДОН'
  },
  {
    'id': 242,
    'name': 'Днепр'
  },
  {
    'id': 243,
    'name': 'Жук'
  },
  {
    'id': 244,
    'name': 'ЗАЗ'
  },
  {
    'id': 245,
    'name': 'ЗИЛ'
  },
  {
    'id': 246,
    'name': 'ЗСА'
  },
  {
    'id': 247,
    'name': 'Зубренок'
  },
  {
    'id': 248,
    'name': 'ИЖ'
  },
  {
    'id': 249,
    'name': 'КАЗ'
  },
  {
    'id': 250,
    'name': 'КВЗ'
  },
  {
    'id': 251,
    'name': 'КТМ'
  },
  {
    'id': 252,
    'name': 'КаВЗ'
  },
  {
    'id': 253,
    'name': 'КамАЗ'
  },
  {
    'id': 254,
    'name': 'Кама'
  },
  {
    'id': 255,
    'name': 'Карпаты'
  },
  {
    'id': 256,
    'name': 'Краз'
  },
  {
    'id': 257,
    'name': 'ЛАЗ'
  },
  {
    'id': 258,
    'name': 'ЛуАЗ'
  },
  {
    'id': 259,
    'name': 'МАЗ'
  },
  {
    'id': 260,
    'name': 'МТ'
  },
  {
    'id': 261,
    'name': 'МТЗ'
  },
  {
    'id': 262,
    'name': 'Минск'
  },
  {
    'id': 263,
    'name': 'МоАЗ'
  },
  {
    'id': 264,
    'name': 'Мопед'
  },
  {
    'id': 265,
    'name': 'Москвич'
  },
  {
    'id': 266,
    'name': 'Муравей'
  },
  {
    'id': 267,
    'name': 'Нива'
  },
  {
    'id': 268,
    'name': 'ПАЗ'
  },
  {
    'id': 269,
    'name': 'ПП'
  },
  {
    'id': 270,
    'name': 'РАФ'
  },
  {
    'id': 271,
    'name': 'Рута'
  },
  {
    'id': 272,
    'name': 'СеАЗ'
  },
  {
    'id': 273,
    'name': 'Т-150'
  },
  {
    'id': 274,
    'name': 'ТАМ'
  },
  {
    'id': 275,
    'name': 'УАЗ'
  },
  {
    'id': 276,
    'name': 'УВН'
  },
  {
    'id': 277,
    'name': 'Урал'
  },
  {
    'id': 278,
    'name': 'ФУА'
  },
  {
    'id': 279,
    'name': 'ХАЗ'
  },
  {
    'id': 280,
    'name': 'ХТЗ'
  },
  {
    'id': 281,
    'name': 'ЧАЗ'
  },
  {
    'id': 282,
    'name': 'Электрон'
  },
  {
    'id': 283,
    'name': 'Причіп'
  },
  {
    'id': 284,
    'name': 'КНОТТ'
  },
];
